<div class="answers" *ngFor="let option of question.data.options; let i = index;">

    <div class="mt-2 mr-2">
        <app-view-quiz-answer-number [number]="i + 1"></app-view-quiz-answer-number>
    </div>

    <div class="answers__option">
        <app-view-quiz-answer-option [correct]="isOptionAnswerCorrect(i)" #answerOption>
            
            <!-- correct -->
            <div class="text-semibold" *ngIf="answerOption.correct; else falseBlock">
                {{ option.label.title }}
            </div>
        
            <!-- incorrect -->
            <ng-template #falseBlock>
                <div>
                    You selected <em class="text-semibold">{{ getSelectedUserOption(i).label.title }}</em>.
                </div>
                <div class="mt-1">
                    This is the <em class="text-semibold">{{ option.label.title }}</em>.
                </div>
            </ng-template>

        </app-view-quiz-answer-option>
    </div>

</div>